export function state(initialState) {
  return {
    verticalOverview: {},
    supplyOverview: {},
    rfqOverview: {},
  };
}
